import { BookOpen } from 'lucide-react'
import {
  Users, ShieldCheck, Route, Zap, Bell, MailOpen, Inbox,
  Database, FileText, ScrollText, SlidersHorizontal,
  FlaskConical, Layers, Box, Workflow, ListTree,
  Key, GitMerge, LayoutDashboard, List, Telescope, Receipt, Blocks,
} from 'lucide-react'
import { useAuth } from '../store/auth'
import { DOCS_URL } from '../api/client'
import { AppLayout } from './layout/AppLayout'
import { HeaderIconButton } from './layout/AppHeader'
import { UserMenu } from './layout/UserMenu'
import type { SidebarSection } from './layout/AppSidebar'
import type { ModuleKey } from '../types'

type NavSection = SidebarSection & { moduleKey?: ModuleKey }

const nav: NavSection[] = [
  {
    title: 'Identity & Access',
    items: [
      { to: '/users', label: 'Users', icon: Users },
      { to: '/roles', label: 'Roles', icon: ShieldCheck },
      { to: '/paths', label: 'Paths', icon: Route },
    ],
  },
  {
    title: 'Events',
    items: [
      { to: '/events', label: 'Events', icon: Zap },
      { to: '/subscriptions', label: 'Subscriptions', icon: Bell },
    ],
  },
  {
    title: 'Mail',
    moduleKey: 'mail-service',
    items: [
      { to: '/mailboxes', label: 'Mailboxes', icon: Inbox },
      { to: '/emails', label: 'Emails', icon: MailOpen },
    ],
  },
  {
    title: 'Invoice Facteur',
    moduleKey: 'invoice-facteur',
    items: [
      { to: '/invoices', label: 'Invoices', icon: Receipt },
    ],
  },
  {
    title: 'Storage',
    moduleKey: 'storage-service',
    items: [
      { to: '/datasets', label: 'Datasets', icon: Database },
      { to: '/documents', label: 'Documents', icon: FileText },
      { to: '/pdf-templates', label: 'PDF Templates', icon: ScrollText },
    ],
  },
  {
    title: 'Configuration',
    items: [
      { to: '/settings', label: 'Settings', icon: SlidersHorizontal },
      { to: '/modules', label: 'Modules', icon: Blocks },
      { to: '/api-keys', label: 'API Keys', icon: Key },
      { to: '/audit-logs', label: 'Audit Logs', icon: ScrollText },
    ],
  },
  {
    title: 'Brainer · Builder',
    moduleKey: 'brainer',
    items: [
      { to: '/brainer/collections', label: 'Collections', icon: List },
      { to: '/brainer/ingredients', label: 'Ingredients', icon: FlaskConical },
      { to: '/brainer/traits', label: 'Traits', icon: Layers },
      { to: '/brainer/cups', label: 'Cups', icon: Box },
      { to: '/brainer/steps', label: 'Steps', icon: ListTree },
      { to: '/brainer/drinkers', label: 'Drinkers', icon: Zap },
      { to: '/brainer/preparations', label: 'Preparations', icon: Workflow },
      { to: '/brainer/funnels', label: 'Connectors', icon: GitMerge },
      { to: '/brainer/plates', label: 'Plates', icon: LayoutDashboard },
    ],
  },
  {
    title: 'Lens · ML',
    moduleKey: 'lens',
    items: [
      { to: '/lens/datasources', label: 'Data Sources', icon: Database },
      { to: '/lens/scenarios', label: 'Scenarios', icon: Telescope },
    ],
  },
]

// Rabbit Console shell — TailAdmin AppLayout (collapsible sidebar + sticky header with search).
export function Layout() {
  const { user } = useAuth()
  const visibleNav = nav.filter(section => !section.moduleKey || user?.enabledModules?.includes(section.moduleKey))

  return (
    <AppLayout
      brand={{ name: 'Rabbit', icon: 'R' }}
      homeTo="/"
      sections={visibleNav}
      search
      headerRight={
        <>
          <HeaderIconButton href={DOCS_URL} title="Open Crawl — Rabbit Documentation" icon={BookOpen} />
          <UserMenu />
        </>
      }
    />
  )
}
